import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _BlankChoices;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import striptags from 'striptags';
import findIndex from 'lodash/findIndex';
import get from 'lodash/get';
import { RadioInput } from '@instructure/ui-radio-input';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { jsx } from '@instructure/emotion';
import ChoiceInput from '../../../../../common/edit/components/ChoiceInput';
import Footer from '../../../../../common/edit/components/Footer';
import generateStyle from './styles';
import t from '@instructure/quiz-i18n/format-message';
import { withStyleOverrides, FormFieldGroup } from '@instructure/quiz-common';
import { normalizeErrors } from '../../../../../../util/normalizeErrors';
import { View } from '@instructure/ui-view';
var BlankChoices = (_dec = withStyleOverrides(generateStyle, null), _dec(_class = (_BlankChoices = /*#__PURE__*/function (_Component) {
  function BlankChoices() {
    var _this2;
    _classCallCheck(this, BlankChoices);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, BlankChoices, [].concat(args));
    _defineProperty(_this2, "_timeouts", []);
    _defineProperty(_this2, "choiceInputRefs", []);
    // ===========
    //   HANDLERS
    // ===========
    _defineProperty(_this2, "updateScoringData", function (value) {
      var correctChoice = _this2.props.choices.find(function (c) {
        return c.id === value;
      });
      _this2.props.updateScoringDataForBlank({
        scoringData: {
          value: value,
          blankText: correctChoice ? correctChoice.itemBody : ''
        }
      });
    });
    _defineProperty(_this2, "updateChoice", function (choiceId, e) {
      // update scoringData if updating correct answer
      if (choiceId === _this2.props.scoringDataForBlank.value) {
        _this2.props.updateScoringDataForBlank({
          scoringData: {
            value: choiceId,
            blankText: e.target.value
          }
        });
      }
      var choice = _this2.props.choices.find(function (c) {
        return c.id === choiceId;
      });
      var mods = _this2.__updateChoices(choice, e);
      _this2.props.updateBlank({
        choices: mods
      });
    });
    _defineProperty(_this2, "handleAddChoice", function () {
      var nextPosition = Math.max.apply(Math, [0].concat(_toConsumableArray(_this2.props.choices.map(function (i) {
        return i.position;
      })))) + 1;
      var mods = _this2.props.choices.concat({
        id: uuid(),
        position: nextPosition,
        itemBody: ''
      });
      _this2.props.updateBlank({
        choices: mods
      });
      _this2.props.notifyScreenreader(t('Added additional choice.'));
      _this2._timeouts = _this2._timeouts.concat(setTimeout(function () {
        var lastInputIndex = _this2.props.choices.length - 1;
        _this2.choiceInputRefs[lastInputIndex].focusOnAnswerInput();
      }));
    });
    _defineProperty(_this2, "handleRemoveChoice", function (choiceId) {
      var mods = _this2.props.choices.filter(function (choice) {
        return choice.id !== choiceId;
      });
      if (choiceId === _this2.props.scoringDataForBlank.value) {
        _this2.updateScoringData(null);
      }
      _this2.props.updateBlank({
        choices: mods
      });
      _this2.props.notifyScreenreader(t('Removed additional choice.'));
      var indexToRemove = findIndex(_this2.props.choices, function (li) {
        return li.id === choiceId;
      });
      _this2._timeouts = _this2._timeouts.concat(setTimeout(function () {
        var choicesLength = _this2.props.choices.length;
        if (choicesLength === 1) {
          _this2.choiceInputRefs[0].focusOnAnswerInput();
        } else if (choicesLength === indexToRemove) {
          _this2.choiceInputRefs[indexToRemove - 1].focusOnRemoveChoice();
        } else {
          _this2.choiceInputRefs[indexToRemove].focusOnRemoveChoice();
        }
      }));
    });
    _defineProperty(_this2, "handleChoiceChange", function (event) {
      _this2.updateScoringData(event.target.value);
    });
    _defineProperty(_this2, "footer", function () {
      return jsx(Footer, {
        notifyScreenreader: _this2.props.notifyScreenreader,
        onCreateChoice: _this2.handleAddChoice
      });
    });
    // ===========
    //   RENDER
    // ===========
    _defineProperty(_this2, "renderChoice", function (choice, choiceIndex) {
      var onlyChoice = _this2.props.choices.length === 1;
      var errors = get(_this2.props.interactionDataErrors, ['choices', choiceIndex, 'itemBody'], []).map(function (error) {
        return {
          text: error,
          type: 'error'
        };
      });
      var isChecked = _this2.props.scoringDataForBlank.value === choice.id;
      var labelText = choice.itemBody.trim() === '' ? t('Radio button for blank answer') : t('Radio button for answer { answer }', {
        answer: striptags(choice.itemBody)
      });
      var renderBeforeComponent = function renderBeforeComponent() {
        return jsx(RadioInput, {
          onChange: _this2.handleChoiceChange,
          name: "radio_for_".concat(_this2.props.blankName),
          label: jsx(ScreenReaderContent, null, labelText),
          value: choice.id,
          checked: isChecked
        });
      };
      return jsx(ChoiceInput, {
        key: choice.id,
        id: choice.id,
        itemBody: choice.itemBody,
        errors: errors,
        onInputChange: _this2.updateChoice,
        onModalClose: _this2.props.onModalClose,
        onModalOpen: _this2.props.onModalOpen,
        onRemoveChoice: _this2.handleRemoveChoice,
        renderLabel: t('Distractor'),
        isRequired: true,
        ref: function ref(node) {
          _this2.choiceInputRefs[choiceIndex] = node;
        },
        focusOnMount: false,
        renderBeforeComponent: renderBeforeComponent(),
        shouldRenderRemoveChoice: !onlyChoice && !_this2.props.disabled,
        removeButtonScreenReaderText: t('Remove Distractor: {choice}', {
          choice: choice.itemBody
        }),
        noRCE: true,
        notifyScreenreader: _this2.props.notifyScreenreader
      });
    });
    return _this2;
  }
  _inherits(BlankChoices, _Component);
  return _createClass(BlankChoices, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._timeouts.forEach(clearTimeout);
    }
  }, {
    key: "__updateChoices",
    value: function __updateChoices(choice, e) {
      var modifiedAnswer = Object.assign({}, choice, {
        itemBody: e.target.value
      });
      var indexToModify = findIndex(this.props.choices, function (li) {
        return li.id === choice.id;
      });
      return Object.assign([], this.props.choices, _defineProperty({}, indexToModify, modifiedAnswer));
    }
  }, {
    key: "render",
    value: function render() {
      this.choiceInputRefs = [];
      return jsx(View, {
        as: "div"
      }, jsx(FormFieldGroup, {
        description: t('Possible Choices'),
        name: "choices_for_".concat(this.props.blankName),
        messages: normalizeErrors(this.props.errors)
      }, this.props.choices.map(this.renderChoice)), !this.props.disabled && this.footer());
    }
  }]);
}(Component), _defineProperty(_BlankChoices, "displayName", 'BlankChoices'), _defineProperty(_BlankChoices, "componentId", "Quizzes".concat(_BlankChoices.displayName)), _defineProperty(_BlankChoices, "propTypes", {
  blankName: PropTypes.string.isRequired,
  choices: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  errors: PropTypes.array,
  interactionDataErrors: PropTypes.object,
  notifyScreenreader: PropTypes.func.isRequired,
  onModalClose: PropTypes.func,
  onModalOpen: PropTypes.func,
  scoringDataForBlank: PropTypes.object.isRequired,
  updateBlank: PropTypes.func.isRequired,
  updateScoringDataForBlank: PropTypes.func.isRequired,
  styles: PropTypes.object
}), _defineProperty(_BlankChoices, "defaultProps", {
  disabled: false,
  errors: void 0,
  interactionDataErrors: void 0,
  onModalClose: void 0,
  onModalOpen: void 0
}), _BlankChoices)) || _class);
export { BlankChoices as default };